<template>
  <div>
    <img
      :src="`/img/logo/${light ? 'anima-logo_normal.svg' : 'anima-logo_normal-white.svg'}`"
      class="h-auto mx-auto"
      :class="width"
      alt="Anima logo"
      width="356.88"
      height="66"
    >
  </div>
</template>

<script lang="ts" setup>
defineProps({
  light: {
    type: Boolean,
    required: false,
    default: true,
  },
  autoMode: {
    type: Boolean,
    required: false,
    default: true,
  },
  width: {
    type: String,
    required: false,
    default: 'w-[180px]',
  },
})
</script>
